/**
 * Parallel router for all /es/* routes.
 *
 * Phase 1 — home, contacto, 404                                    (DONE)
 * Phase 2 Batch 1 — services index + 6 priority service pages,
 *                   sobre-nosotros, promociones, blog landing       (DONE)
 * Phase 2 Batch 2 — remaining 18 services + Team/Offices/Testimonials/
 *                   Financing/Areas/PressReleases/ImplantCenter+5/
 *                   5 special detail pages + 11 SEO landing pages +
 *                   Legal x4                                         (DONE)
 * Phase 3 — auto-translated blog posts                              (TODO)
 *
 * IMPORTANT: keep slugs in sync with /app/frontend/src/i18n/routeMap.js so
 * <LangToggle /> can flip between EN and ES correctly.
 */
import React from 'react';
import { Routes, Route } from 'react-router-dom';

import SpanishHomePage from '@/pages/es/SpanishHomePage';
import SpanishContactPage from '@/pages/es/SpanishContactPage';
import SpanishAboutPage from '@/pages/es/SpanishAboutPage';
import SpanishServicesIndex from '@/pages/es/SpanishServicesIndex';
import SpanishSpecialsPage from '@/pages/es/SpanishSpecialsPage';
import SpanishBlogIndex from '@/pages/es/SpanishBlogIndex';
import SpanishBlogPost from '@/pages/es/SpanishBlogPost';
import SpanishOurTeamPage from '@/pages/es/SpanishOurTeamPage';
import SpanishFinancingPage from '@/pages/es/SpanishFinancingPage';
import SpanishTestimonialsPage from '@/pages/es/SpanishTestimonialsPage';
import SpanishAreasPage from '@/pages/es/SpanishAreasPage';
import SpanishNotFound from '@/pages/es/SpanishNotFound';
import SpanishServiceTemplate from '@/components/SpanishServiceTemplate';
import SpanishContentPage from '@/components/SpanishContentPage';
import SpanishExitPopup from '@/components/SpanishExitPopup';
import SpanishServiceAreaPage from '@/pages/es/SpanishServiceAreaPage';

import { SPANISH_SERVICES } from '@/i18n/spanishServicesData';
import { SPANISH_PAGES } from '@/i18n/spanishPagesData';

const EsRouter = () => (
  <>
    <Routes>
      {/* Home */}
      <Route index element={<SpanishHomePage />} />

      {/* Bespoke pages */}
      <Route path="contacto" element={<SpanishContactPage />} />
      <Route path="sobre-nosotros" element={<SpanishAboutPage />} />
      <Route path="servicios" element={<SpanishServicesIndex />} />
      <Route path="promociones" element={<SpanishSpecialsPage />} />
      <Route path="blog" element={<SpanishBlogIndex />} />
      <Route path="blog/:slug" element={<SpanishBlogPost />} />
      <Route path="nuestro-equipo" element={<SpanishOurTeamPage />} />
      <Route path="financiamiento" element={<SpanishFinancingPage />} />
      <Route path="testimonios" element={<SpanishTestimonialsPage />} />
      <Route path="areas-que-atendemos" element={<SpanishAreasPage />} />

      {/* All 24 service pages — rendered via SpanishServiceTemplate */}
      {Object.values(SPANISH_SERVICES).map((s) => (
        <Route
          key={s.slug}
          path={s.slug}
          element={<SpanishServiceTemplate content={s} />}
        />
      ))}

      {/* All hub/info pages — rendered via SpanishContentPage.
          Path key includes the full sub-path (e.g., "centro-de-implantes/mini-implantes"
          or "promociones/limpieza-179"), which React Router treats as nested. */}
      {Object.entries(SPANISH_PAGES).map(([key, content]) => (
        <Route
          key={key}
          path={key}
          element={<SpanishContentPage content={content} />}
        />
      ))}

      {/* Dynamic Spanish service-area pages — /es/{service-es}-{city-slug}
          (e.g., /es/implantes-dentales-arlington). Must come AFTER all
          bespoke ES routes so it acts as a fallback before SpanishNotFound. */}
      <Route path=":slug" element={<SpanishServiceAreaPage />} />

      <Route path="*" element={<SpanishNotFound />} />
    </Routes>
    <SpanishExitPopup />
  </>
);

export default EsRouter;
